import { FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  '.MuiTypography-root': {
    fontSize: 13
  }
}))

export default StyledFormControlLabel
